<template>
	<!-- <v-empty-state
		:headline="headline"
		:icon="icon"
		:title="title"
	> -->
		<v-container>
			<v-card
				class="mx-auto pa-12 pb-8"
				elevation="1"
				max-width="448"
				rounded="lg"
			>
				<div class="text-subtitle-1 text-medium-emphasis">Account</div>

				<v-form ref="form">
					<v-text-field
						v-model="item.login"
						density="compact"
						placeholder="Email address"
						prepend-inner-icon="mdi-email-outline"
						variant="outlined"
					></v-text-field>

					<div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
						Password

						<!-- <a
						class="text-caption text-decoration-none text-blue"
						href="#"
						rel="noopener noreferrer"
						target="_blank"
						>Forgot login password?</a> -->
					</div>

					<v-text-field
						v-model="item.password"
						:append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
						:type="visible ? 'text' : 'password'"
						density="compact"
						placeholder="Enter your password"
						prepend-inner-icon="mdi-lock-outline"
						variant="outlined"
						@click:append-inner="visible = !visible"
					></v-text-field>
				</v-form>

				<v-card
					class="mb-12"
					color="surface-variant"
					variant="tonal"
				>
					<v-card-text class="text-medium-emphasis text-caption">
					Warning: After 3 consecutive failed login attempts, you account will be temporarily locked for three hours. If you must login now, you can also click "Forgot login password?" below to reset the login password.
					</v-card-text>
				</v-card>

				<v-btn
					class="mb-8"
					color="blue"
					size="large"
					variant="tonal"
					block
					@click="onOK"
				>
					Log In
				</v-btn>

				<!-- <v-card-text class="text-center">
					<a
						class="text-blue text-decoration-none"
						href="#"
						rel="noopener noreferrer"
						target="_blank"
					>
						Sign up now <v-icon icon="mdi-chevron-right"></v-icon>
					</a>
				</v-card-text> -->
			</v-card>
		</v-container>

		<!-- <template v-slot:text>
			<div class="text-medium-emphasis text-caption">
				Great job on completing all your tasks! This might be a good time to relax or consider planning your next set of goals. If you think of something new, just hit the button below to add a new task.
			</div>
		</template> -->
	<!-- </v-empty-state> -->
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'Home',
	components: {},
	computed: {
		//...mapGetters([ 'system' ]),
	},
	data: () => ({
		headline: 'Login',
		title: 'Login',
		icon: 'mdi-login',
		visible: false,
		item: {},
	}),

	methods: {
		...mapActions([ 'setUser' ]),

		login() {
			var that = this

			//console.log(that.$options.name, 'login', 'baseURL', axios.defaults.baseURL)
			//console.log(that.$options.name, 'login', 'item', this.item)
			
			return axios.post('/security/login', this.item).then(response => {
				//console.log(that.$options.name, 'login', 'data', response.data)

				let token = response.data?.token
				if(token) {
					localStorage.setItem('X-Api-Key', token)
					axios.defaults.headers.common['X-Api-Key'] = token;
				}
			}, error => {
				console.log('error', error)
			})
		},

		/* login() {
			var that = this

			
			console.log('Login', 'login', 'baseURL', axios.defaults.baseURL)


			return this.$refs.form?.validate().then(({ valid: isValid }) => {
				if(isValid) {
					
					this.loading = true;
					axios.post('/security/login', this.item).then(response => {
						//console.log('Login','OnOk', 'data', response.data)

						let token = response.data?.token
						if(token) {
							localStorage.setItem('token', token)
							axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
						}
					}, error => {
						console.log('error', error)
					}).finally(() => (this.loading = false));
				}
			})
		}, */

		onOK() {
			//this.login()
			this.$refs.form?.validate().then(({ valid: isValid }) => {
				if(isValid) {
					this.loading = true;
					this.login().then(() => this.$router.push({ name: 'Loss' }).catch(err => {})).finally(() => (this.loading = false));
				}
			})

		},
	},
}
</script>
